import { useLazyQuery } from '@apollo/client'
import { Download, UploadFile } from '@mui/icons-material'
import { IconButton, Stack, Typography } from '@mui/material'
import { downloadDocument } from 'candidate/graphql/profile.gql'
import useToast from 'shared/components/Toast/useToast'
import { getPxAsRem } from 'shared/utils'

interface DownloadResumeProps {
    documents: {
        documentKey: string
        documentType?: string | null
        id: string
    }[]
}

export default function DownloadResume(props: DownloadResumeProps) {
    const toast = useToast()

    const [download] = useLazyQuery(downloadDocument, {
        fetchPolicy: 'network-only',
    })

    const resume = props.documents?.find((doc) => doc.documentType === 'Resume')

    const handleDownloadClick = async (id: string) => {
        const { data } = await download({ variables: { documentId: id } })
        if (data?.download?.url) {
            const hiddenDownloadLink = document.createElement('a')
            hiddenDownloadLink.href = data.download.url
            hiddenDownloadLink.target = '_blank'
            hiddenDownloadLink.click()
            hiddenDownloadLink.remove()
        } else {
            toast({
                title: 'Something went wrong',
                message: 'Please try again later.',
            })
        }
    }

    if (!resume) {
        return 'No resume available'
    }

    return (
        <>
            <Stack direction="row" alignItems="center" gap={getPxAsRem(30)}>
                <UploadFile color="primary" fontSize="medium" />
                <Typography variant="body1">
                    {formatDocumentKey(resume?.documentKey) ||
                        'No resume available.'}
                </Typography>
            </Stack>
            <IconButton
                size="small"
                onClick={() => handleDownloadClick(resume.id || '')}
            >
                <Download fontSize="small" />
            </IconButton>
        </>
    )
}

const formatDocumentKey = (docKey: string) => {
    // remove the folder path and candidateId from the document key (if present, seed data doesn't have it)
    if (docKey.includes('/')) {
        const splitDocKey = docKey.split('/')
        return splitDocKey[splitDocKey.length - 1]
    } else {
        return docKey
    }
}
